export default __webpack_public_path__ + "static/media/5_Conin_entrega_de_reconocimientos.62e7e4c5.mp3";